/**
 * Factory for the audio-merge Web Worker.
 *
 * Isolated into its own module because `import.meta.url` is an ESM-only
 * syntax that crashes Jest's CJS transform at parse time.  By keeping it
 * in a separate file we can:
 *   – let the prod bundler (Webpack 5 / Vite) inline the worker asset, and
 *   – let Jest mock this entire module trivially (returns `null`).
 */

/**
 * @returns a new Worker instance, or `null` if the environment doesn't
 *          support `import.meta.url` or Web Workers.
 */
export function createAudioMergeWorker(): Worker | null {
  try {
    return new Worker(
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore – import.meta.url is ESM-only; safe because prod always uses a bundler
      new URL('./audio-merge.worker.ts', import.meta.url),
    );
  } catch {
    return null;
  }
}
